import React, { useEffect, useState } from 'react';
import { Leaf, MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_LINKS = [{
  label: 'Método',
  id: 'method'
}, {
  label: 'Contenido',
  id: 'content'
}, {
  label: 'Resultados',
  id: 'results'
}, {
  label: 'Precio',
  id: 'pricing'
}, {
  label: 'FAQ',
  id: 'faq'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-sage-100' : 'bg-transparent'}`} data-id="element-71">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-72">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-73">
          {/* Logo / Brand */}
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="flex items-center gap-2 cursor-pointer" data-id="element-74">
            <div className="w-9 h-9 bg-sage-600 rounded-full flex items-center justify-center" data-id="element-75">
              <Leaf className="w-5 h-5 text-white" data-id="element-76" />
            </div>
            <span className="text-lg md:text-xl font-serif font-bold text-sage-900" data-id="element-77">
              Vientre Plano 55+
            </span>
          </button>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-8" data-id="element-78">
            {NAV_LINKS.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-sm font-semibold text-sage-700 hover:text-sage-900 transition-colors cursor-pointer" data-id="element-79">
                {link.label}
              </button>)}
            <button onClick={() => scrollTo('pricing')} className="px-5 py-2.5 text-sm font-bold text-white bg-sage-600 rounded-full hover:bg-sage-700 transition-all cursor-pointer" data-id="element-80">
              Comprar Ahora
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 text-sage-700 cursor-pointer" aria-label="Toggle menu" data-id="element-81">
            {mobileOpen ? <XIcon className="w-6 h-6" data-id="element-82" /> : <MenuIcon className="w-6 h-6" data-id="element-83" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-84">
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden bg-white border-b border-sage-100 overflow-hidden" data-id="element-85">
            <div className="px-6 py-4 space-y-1" data-id="element-86">
              {NAV_LINKS.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="block w-full text-left py-3 text-base font-semibold text-sage-700 hover:text-sage-900 transition-colors cursor-pointer" data-id="element-87">
                  {link.label}
                </button>)}
              <button onClick={() => scrollTo('pricing')} className="w-full mt-2 px-5 py-3 text-base font-bold text-white bg-sage-600 rounded-full hover:bg-sage-700 transition-all cursor-pointer" data-id="element-88">
                Comprar Ahora
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}